/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.SpareParts.Purchase.NonShop.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProblemDetails } from '../model';
/**
 * AssetApi - axios parameter creator
 * @export
 */
export const AssetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return explosion drawing asset by given FileName
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetExplosiondrawingFileNameGet: async (fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('v1AssetExplosiondrawingFileNameGet', 'fileName', fileName)
            const localVarPath = `/v1/asset/explosiondrawing/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return filenames (used for explosion drawings and hotspots) by given appliance service number
         * @param {string} serviceNumberAppliance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetServiceNumberApplianceExplosiondrawingGet: async (serviceNumberAppliance: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1AssetServiceNumberApplianceExplosiondrawingGet', 'serviceNumberAppliance', serviceNumberAppliance)
            const localVarPath = `/v1/asset/{serviceNumberAppliance}/explosiondrawing`
                .replace(`{${"serviceNumberAppliance"}}`, encodeURIComponent(String(serviceNumberAppliance)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetApi - functional programming interface
 * @export
 */
export const AssetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return explosion drawing asset by given FileName
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssetExplosiondrawingFileNameGet(fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AssetExplosiondrawingFileNameGet(fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.v1AssetExplosiondrawingFileNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return filenames (used for explosion drawings and hotspots) by given appliance service number
         * @param {string} serviceNumberAppliance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.v1AssetServiceNumberApplianceExplosiondrawingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetApi - factory interface
 * @export
 */
export const AssetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetApiFp(configuration)
    return {
        /**
         * 
         * @summary Return explosion drawing asset by given FileName
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetExplosiondrawingFileNameGet(fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1AssetExplosiondrawingFileNameGet(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return filenames (used for explosion drawings and hotspots) by given appliance service number
         * @param {string} serviceNumberAppliance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetApi - interface
 * @export
 * @interface AssetApi
 */
export interface AssetApiInterface {
    /**
     * 
     * @summary Return explosion drawing asset by given FileName
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApiInterface
     */
    v1AssetExplosiondrawingFileNameGet(fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Return filenames (used for explosion drawings and hotspots) by given appliance service number
     * @param {string} serviceNumberAppliance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApiInterface
     */
    v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * AssetApi - object-oriented interface
 * @export
 * @class AssetApi
 * @extends {BaseAPI}
 */
export class AssetApi extends BaseAPI implements AssetApiInterface {
    /**
     * 
     * @summary Return explosion drawing asset by given FileName
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public v1AssetExplosiondrawingFileNameGet(fileName: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).v1AssetExplosiondrawingFileNameGet(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return filenames (used for explosion drawings and hotspots) by given appliance service number
     * @param {string} serviceNumberAppliance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetApi
     */
    public v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance: string, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).v1AssetServiceNumberApplianceExplosiondrawingGet(serviceNumberAppliance, options).then((request) => request(this.axios, this.basePath));
    }
}

